var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isshare)?_c('div',[_c('div',{staticClass:"mcover",attrs:{"id":"mcover"},on:{"click":()=>{_vm.$emit('click',false)}}},[_c('img',{attrs:{"src":_vm.tishi,"alt":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }